import { EnumService } from './enum.service';
import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';
import { IContact } from "./contacts.service";
import { ISalaryScaleGroup } from "./salaryScaleGroup.service";
import * as _ from "lodash";

export class IAccount {
    id: string;
    name: string;
    salaryScaleGroupId?: string;
    salaryScaleGroup?: ISalaryScaleGroup;
    caoSurcharge?: number;
    /** Doorbelasten gelijkwaardige beloning bruto op factuur (Nmbrs blijft op CAO-percentage). */
    chargeGrossWageAllowanceOnInvoice?: boolean;
    /** 0 = volg CAO, 1 = aan, 2 = uit */
    sleepShiftOrtRulesOverride?: number;
}

export class AccountsService extends BaseService<IAccount> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService, private EnumService: EnumService) {
        "ngInject";
        super(Restangular, AppService, 'crm/accounts');
    }

    public getContacts = (id) : ng.IPromise<IContact[]> => {
        return this.one(id).all('contacts').getList().then((result: any) => {
            let contacts = result.value;
            contacts.forEach(item => {
                item.name = item.firstName + ' ' + item.lastName;
            });
            return contacts.plain();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/accounts.service.ts